<template>
  <div
    ref="background"
    :class="$style.background"
  />
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, useTemplateRef, watch } from 'vue';
import type { BackgroundAnimation } from './background-animation';
import { retrieveBackgroundAnimation, releaseBackgroundAnimation } from './backgrounds-pool';

type Props = {
  width?: number;
  stopAnimation?: boolean;
};

const { width = 55, stopAnimation = false } = defineProps<Props>();

let backgroundAnimationData: BackgroundAnimation | null = null;
const background = useTemplateRef<HTMLElement>('background');

onMounted(() => {
  if (background.value) {
    backgroundAnimationData = retrieveBackgroundAnimation({
      refraction: 0.15,
      offset: 0.18,
      speed: 0.03,
      curvature: 1.0,
      width,
      fps: 30
    });
    backgroundAnimationData.attach(background.value);
  }
});

watch(
  () => stopAnimation,
  (value) => {
    if (value) {
      backgroundAnimationData.release();
    }
  }
);

onBeforeUnmount(() => {
  if (backgroundAnimationData) {
    releaseBackgroundAnimation(backgroundAnimationData);
  }
});
</script>

<style module>
.background {
  display: flex;
  height: 100%;
  border-radius: 16px;
  overflow: hidden;
}
</style>

<i18n lang="json">{}</i18n>
